import { render, staticRenderFns } from "./PaymentTermSelector.vue?vue&type=template&id=11202f0f"
import script from "./PaymentTermSelector.vue?vue&type=script&lang=js"
export * from "./PaymentTermSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports